import { stateOptions } from '../commonStateTaxData';

export const step1Questions = [
  {
    id: 'employee_name',
    title: 'Employee name',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'employee_ssn',
    title: 'Employee Social Security number',
    is_required: true,
    placeholder: '9 digits',
    question_type: 'identity',
    identity_type: 'ssn',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{9}$',
      },
    ],
  },
  {
    id: 'street_address',
    title: 'Street Address',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'city_or_town',
    title: 'City or town',
    is_required: true,
    question_type: 'short_text',
  },
  {
    id: 'state',
    title: 'State',
    is_required: true,
    question_type: 'dropdown',
    options: stateOptions,
  },
  {
    id: 'zip_code',
    title: 'Zip code',
    is_required: true,
    question_type: 'short_text',
    placeholder: '5 digits',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^\\d{5}$',
      },
    ],
  },
];

export const step1QuestionsPart2 = [
  {
    id: 'personal_exemption_is_allowed',
    content: 'If you are single or married filing separately, a $1,500 personal exemption is allowed. If you are married or single claiming head of family, a $3,000 personal exemption is allowed.',
    question_type: 'text_heading',
  },
  {
    id: 'filing_status',
    title: 'Select a filing status to claim an exemption:',
    is_required: true,
    question_type: 'multiple_choice',
    options: [
      {
        codeValue: 'single',
        shortName: 'Single',
      },
      {
        codeValue: 'married_filing_separately',
        shortName: 'Married separately',
      },
      {
        codeValue: 'married',
        shortName: 'Married',
      },
      {
        codeValue: 'head_of_household',
        shortName: 'Single claiming head of family',
      },
    ],
  },
  {
    id: 'dependents',
    title: 'Number of dependents (other than spouse) that you will provide more than one-half of the support for during the year.',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
      {
        value: '100',
        action: 'lte',
        category: 'number',
      },
    ],
  },
  {
    id: 'additional_amount',
    title: 'Additional amount, if any, you want deducted each pay period.',
    question_type: 'short_text',
    rules: [
      {
        category: 'regex',
        action: 'match',
        value: '^(0|[1-9][0-9]*)$',
      },
    ],
  },
];

export default step1Questions;
